import { ApiErrorType } from "../interfaces/all";

export const ERROR_MESSAGES: Record<ApiErrorType, string> = {
  validation: "Por favor, verifique os dados informados",
  authentication: "Sua sessão expirou. Por favor, faça login novamente",
  authorization: "Você não tem permissão para realizar esta ação",
  not_found: "O recurso solicitado não foi encontrado",
  database: "Ocorreu um erro ao acessar os dados",
  business: "Não foi possível realizar esta operação",
  internal: "Ocorreu um erro inesperado. Tente novamente mais tarde",
} as const;
